import { BASE_FRONTEND_PATH } from 'config/shared';
const LOGIN_PATH = `${BASE_FRONTEND_PATH}login`;

/// Some of our fetching logic doesn't really use react -- just plain
/// javascript/typescript.  So we can't hook into the react state cycle and
/// properly clear login state and navigate to `/login` using the proper
/// react-style mechanisms.
///
/// However, some of the fetching code _does_ do it properly through
/// react-router-dom and other hooks.
///
/// This function is a failover such that if the proper react way does not
/// accomplish the login state reset and react-router-dom navigation, then this
/// function will failover to an old-school javascript navigation using
/// window.location manipulation.
///
/// This is necessary because some pages are composed _solely_ of fetches which
/// do not have proper react-style fetching.
export const unauthorizedRedirectFallback = () =>
  setTimeout(() => {
    if (window.location.pathname !== LOGIN_PATH) {
      console.log('Standard react re-login logic not executed. Falling back.');
      window.location.pathname = LOGIN_PATH;
    }
  }, 700);
